import { ICellRendererParams } from 'ag-grid-community';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import EllipsisText from '@cp/src/components/EllipsisText';
import { Button } from '@primitives';

const VIEW_SEGMENTS_COL_DEFS = (handleViewCriteriaModal: (criteria: string) => void) => {
  return [
    {
      field: 'id',
      headerName: 'Segment ID',
      // minWidth: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return <div>{params.value}</div>;
      }
    },
    {
      field: 'name',
      headerName: 'Segment Name',
      // minWidth: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <Tooltip placement="top" hiddenPadding={0} hideStrategy="referenceHidden">
            <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
              <EllipsisText text={params.value} />
            </TooltipTrigger>
            <TooltipContent className="tooltipWrapper">{params.value}</TooltipContent>
          </Tooltip>
        );
      }
    },
    {
      field: 'engine',
      headerName: 'Engine',
      serverSortable: true,
      // width: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return <EllipsisText text={params.value} />;
      }
    },

    {
      field: 'description',
      headerName: 'Description',
      serverSortable: true,
      // width: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return <EllipsisText text={params.value} />;
      }
    },
    {
      field: 'criteria',
      headerName: 'View Criteria',
      serverSortable: true,
      autoHeight: true,
      // width: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return <Button onClick={() => handleViewCriteriaModal(params.value)}>View Criteria</Button>;
      }
    }
  ];
};

export default VIEW_SEGMENTS_COL_DEFS;
